// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import { makeIcon } from "./makeIcon";

export const IconAccessibility = /*#__PURE__*/ makeIcon(
  "accessibility",
  new URL("./sprites/accessibility.svg", import.meta.url).href,
);
export const IconActivity = /*#__PURE__*/ makeIcon("activity", new URL("./sprites/activity.svg", import.meta.url).href);
export const IconAirplane = /*#__PURE__*/ makeIcon("airplane", new URL("./sprites/airplane.svg", import.meta.url).href);
export const IconAlarm = /*#__PURE__*/ makeIcon("alarm", new URL("./sprites/alarm.svg", import.meta.url).href);
export const IconAlarmFilled = /*#__PURE__*/ makeIcon(
  "alarmFilled",
  new URL("./sprites/alarmFilled.svg", import.meta.url).href,
);
export const IconAlertCircle = /*#__PURE__*/ makeIcon(
  "alertCircle",
  new URL("./sprites/alertCircle.svg", import.meta.url).href,
);
export const IconAlertCircleFilled = /*#__PURE__*/ makeIcon(
  "alertCircleFilled",
  new URL("./sprites/alertCircleFilled.svg", import.meta.url).href,
);
export const IconAlertOffFilled = /*#__PURE__*/ makeIcon(
  "alertOffFilled",
  new URL("./sprites/alertOffFilled.svg", import.meta.url).href,
);
export const IconAlertOn = /*#__PURE__*/ makeIcon("alertOn", new URL("./sprites/alertOn.svg", import.meta.url).href);
export const IconAlertOnFilled = /*#__PURE__*/ makeIcon(
  "alertOnFilled",
  new URL("./sprites/alertOnFilled.svg", import.meta.url).href,
);
export const IconAlertTriangle = /*#__PURE__*/ makeIcon(
  "alertTriangle",
  new URL("./sprites/alertTriangle.svg", import.meta.url).href,
);
export const IconAlertTriangleFilled = /*#__PURE__*/ makeIcon(
  "alertTriangleFilled",
  new URL("./sprites/alertTriangleFilled.svg", import.meta.url).href,
);
export const IconApple = /*#__PURE__*/ makeIcon("apple", new URL("./sprites/apple.svg", import.meta.url).href);
export const IconArchive = /*#__PURE__*/ makeIcon("archive", new URL("./sprites/archive.svg", import.meta.url).href);
export const IconArrowDown = /*#__PURE__*/ makeIcon(
  "arrowDown",
  new URL("./sprites/arrowDown.svg", import.meta.url).href,
);
export const IconArrowDownLeft = /*#__PURE__*/ makeIcon(
  "arrowDownLeft",
  new URL("./sprites/arrowDownLeft.svg", import.meta.url).href,
);
export const IconArrowDownRight = /*#__PURE__*/ makeIcon(
  "arrowDownRight",
  new URL("./sprites/arrowDownRight.svg", import.meta.url).href,
);
export const IconArrowLeft = /*#__PURE__*/ makeIcon(
  "arrowLeft",
  new URL("./sprites/arrowLeft.svg", import.meta.url).href,
);
export const IconArrowLeftSmall = /*#__PURE__*/ makeIcon(
  "arrowLeftSmall",
  new URL("./sprites/arrowLeftSmall.svg", import.meta.url).href,
);
export const IconArrowRight = /*#__PURE__*/ makeIcon(
  "arrowRight",
  new URL("./sprites/arrowRight.svg", import.meta.url).href,
);
export const IconArrowRightSmall = /*#__PURE__*/ makeIcon(
  "arrowRightSmall",
  new URL("./sprites/arrowRightSmall.svg", import.meta.url).href,
);
export const IconArrowUp = /*#__PURE__*/ makeIcon("arrowUp", new URL("./sprites/arrowUp.svg", import.meta.url).href);
export const IconArrowUpLeft = /*#__PURE__*/ makeIcon(
  "arrowUpLeft",
  new URL("./sprites/arrowUpLeft.svg", import.meta.url).href,
);
export const IconArrowUpRight = /*#__PURE__*/ makeIcon(
  "arrowUpRight",
  new URL("./sprites/arrowUpRight.svg", import.meta.url).href,
);
export const IconArrowsCrossHorizonal = /*#__PURE__*/ makeIcon(
  "arrowsCrossHorizonal",
  new URL("./sprites/arrowsCrossHorizonal.svg", import.meta.url).href,
);
export const IconArrowsCrossVertical = /*#__PURE__*/ makeIcon(
  "arrowsCrossVertical",
  new URL("./sprites/arrowsCrossVertical.svg", import.meta.url).href,
);
export const IconAttach = /*#__PURE__*/ makeIcon("attach", new URL("./sprites/attach.svg", import.meta.url).href);
export const IconAudioMeter = /*#__PURE__*/ makeIcon(
  "audioMeter",
  new URL("./sprites/audioMeter.svg", import.meta.url).href,
);
export const IconAward = /*#__PURE__*/ makeIcon("award", new URL("./sprites/award.svg", import.meta.url).href);
export const IconBackTen = /*#__PURE__*/ makeIcon("backTen", new URL("./sprites/backTen.svg", import.meta.url).href);
export const IconBackpack = /*#__PURE__*/ makeIcon("backpack", new URL("./sprites/backpack.svg", import.meta.url).href);
export const IconBook = /*#__PURE__*/ makeIcon("book", new URL("./sprites/book.svg", import.meta.url).href);
export const IconBookOpen = /*#__PURE__*/ makeIcon("bookOpen", new URL("./sprites/bookOpen.svg", import.meta.url).href);
export const IconBookOpenFilled = /*#__PURE__*/ makeIcon(
  "bookOpenFilled",
  new URL("./sprites/bookOpenFilled.svg", import.meta.url).href,
);
export const IconBookmark = /*#__PURE__*/ makeIcon("bookmark", new URL("./sprites/bookmark.svg", import.meta.url).href);
export const IconBox = /*#__PURE__*/ makeIcon("box", new URL("./sprites/box.svg", import.meta.url).href);
export const IconBrightnessDown = /*#__PURE__*/ makeIcon(
  "brightnessDown",
  new URL("./sprites/brightnessDown.svg", import.meta.url).href,
);
export const IconBrightnessUp = /*#__PURE__*/ makeIcon(
  "brightnessUp",
  new URL("./sprites/brightnessUp.svg", import.meta.url).href,
);
export const IconBruce = /*#__PURE__*/ makeIcon("bruce", new URL("./sprites/bruce.svg", import.meta.url).href);
export const IconBrush = /*#__PURE__*/ makeIcon("brush", new URL("./sprites/brush.svg", import.meta.url).href);
export const IconBunny = /*#__PURE__*/ makeIcon("bunny", new URL("./sprites/bunny.svg", import.meta.url).href);
export const IconCalculator = /*#__PURE__*/ makeIcon(
  "calculator",
  new URL("./sprites/calculator.svg", import.meta.url).href,
);
export const IconCalculatorFilled = /*#__PURE__*/ makeIcon(
  "calculatorFilled",
  new URL("./sprites/calculatorFilled.svg", import.meta.url).href,
);
export const IconCalendar = /*#__PURE__*/ makeIcon("calendar", new URL("./sprites/calendar.svg", import.meta.url).href);
export const IconCalendarDelete = /*#__PURE__*/ makeIcon(
  "calendarDelete",
  new URL("./sprites/calendarDelete.svg", import.meta.url).href,
);
export const IconCalendarFilled = /*#__PURE__*/ makeIcon(
  "calendarFilled",
  new URL("./sprites/calendarFilled.svg", import.meta.url).href,
);
export const IconCalendarMove = /*#__PURE__*/ makeIcon(
  "calendarMove",
  new URL("./sprites/calendarMove.svg", import.meta.url).href,
);
export const IconCamera = /*#__PURE__*/ makeIcon("camera", new URL("./sprites/camera.svg", import.meta.url).href);
export const IconCameraFilled = /*#__PURE__*/ makeIcon(
  "cameraFilled",
  new URL("./sprites/cameraFilled.svg", import.meta.url).href,
);
export const IconCameraSwap = /*#__PURE__*/ makeIcon(
  "cameraSwap",
  new URL("./sprites/cameraSwap.svg", import.meta.url).href,
);
export const IconCast = /*#__PURE__*/ makeIcon("cast", new URL("./sprites/cast.svg", import.meta.url).href);
export const IconChart = /*#__PURE__*/ makeIcon("chart", new URL("./sprites/chart.svg", import.meta.url).href);
export const IconCheck = /*#__PURE__*/ makeIcon("check", new URL("./sprites/check.svg", import.meta.url).href);
export const IconCheckBoxFilled = /*#__PURE__*/ makeIcon(
  "checkBoxFilled",
  new URL("./sprites/checkBoxFilled.svg", import.meta.url).href,
);
export const IconCheckCircle = /*#__PURE__*/ makeIcon(
  "checkCircle",
  new URL("./sprites/checkCircle.svg", import.meta.url).href,
);
export const IconCheckCircleFilled = /*#__PURE__*/ makeIcon(
  "checkCircleFilled",
  new URL("./sprites/checkCircleFilled.svg", import.meta.url).href,
);
export const IconChevronDown = /*#__PURE__*/ makeIcon(
  "chevronDown",
  new URL("./sprites/chevronDown.svg", import.meta.url).href,
);
export const IconChevronDownSmall = /*#__PURE__*/ makeIcon(
  "chevronDownSmall",
  new URL("./sprites/chevronDownSmall.svg", import.meta.url).href,
);
export const IconChevronLeft = /*#__PURE__*/ makeIcon(
  "chevronLeft",
  new URL("./sprites/chevronLeft.svg", import.meta.url).href,
);
export const IconChevronLeftSmall = /*#__PURE__*/ makeIcon(
  "chevronLeftSmall",
  new URL("./sprites/chevronLeftSmall.svg", import.meta.url).href,
);
export const IconChevronRight = /*#__PURE__*/ makeIcon(
  "chevronRight",
  new URL("./sprites/chevronRight.svg", import.meta.url).href,
);
export const IconChevronRightSmall = /*#__PURE__*/ makeIcon(
  "chevronRightSmall",
  new URL("./sprites/chevronRightSmall.svg", import.meta.url).href,
);
export const IconChevronUp = /*#__PURE__*/ makeIcon(
  "chevronUp",
  new URL("./sprites/chevronUp.svg", import.meta.url).href,
);
export const IconChevronUpSmall = /*#__PURE__*/ makeIcon(
  "chevronUpSmall",
  new URL("./sprites/chevronUpSmall.svg", import.meta.url).href,
);
export const IconCircle = /*#__PURE__*/ makeIcon("circle", new URL("./sprites/circle.svg", import.meta.url).href);
export const IconCircleFilled = /*#__PURE__*/ makeIcon(
  "circleFilled",
  new URL("./sprites/circleFilled.svg", import.meta.url).href,
);
export const IconClassroom = /*#__PURE__*/ makeIcon(
  "classroom",
  new URL("./sprites/classroom.svg", import.meta.url).href,
);
export const IconClassroomFilled = /*#__PURE__*/ makeIcon(
  "classroomFilled",
  new URL("./sprites/classroomFilled.svg", import.meta.url).href,
);
export const IconClock = /*#__PURE__*/ makeIcon("clock", new URL("./sprites/clock.svg", import.meta.url).href);
export const IconClockFilled = /*#__PURE__*/ makeIcon(
  "clockFilled",
  new URL("./sprites/clockFilled.svg", import.meta.url).href,
);
export const IconCloud = /*#__PURE__*/ makeIcon("cloud", new URL("./sprites/cloud.svg", import.meta.url).href);
export const IconCloudFilled = /*#__PURE__*/ makeIcon(
  "cloudFilled",
  new URL("./sprites/cloudFilled.svg", import.meta.url).href,
);
export const IconCloudFilledOffline = /*#__PURE__*/ makeIcon(
  "cloudFilledOffline",
  new URL("./sprites/cloudFilledOffline.svg", import.meta.url).href,
);
export const IconCloudOffline = /*#__PURE__*/ makeIcon(
  "cloudOffline",
  new URL("./sprites/cloudOffline.svg", import.meta.url).href,
);
export const IconCollapse = /*#__PURE__*/ makeIcon("collapse", new URL("./sprites/collapse.svg", import.meta.url).href);
export const IconCompose = /*#__PURE__*/ makeIcon("compose", new URL("./sprites/compose.svg", import.meta.url).href);
export const IconConversation = /*#__PURE__*/ makeIcon(
  "conversation",
  new URL("./sprites/conversation.svg", import.meta.url).href,
);
export const IconConversationFilled = /*#__PURE__*/ makeIcon(
  "conversationFilled",
  new URL("./sprites/conversationFilled.svg", import.meta.url).href,
);
export const IconCopy = /*#__PURE__*/ makeIcon("copy", new URL("./sprites/copy.svg", import.meta.url).href);
export const IconCreditcard = /*#__PURE__*/ makeIcon(
  "creditcard",
  new URL("./sprites/creditcard.svg", import.meta.url).href,
);
export const IconDeviceComputer = /*#__PURE__*/ makeIcon(
  "deviceComputer",
  new URL("./sprites/deviceComputer.svg", import.meta.url).href,
);
export const IconDeviceMobile = /*#__PURE__*/ makeIcon(
  "deviceMobile",
  new URL("./sprites/deviceMobile.svg", import.meta.url).href,
);
export const IconDeviceMonitor = /*#__PURE__*/ makeIcon(
  "deviceMonitor",
  new URL("./sprites/deviceMonitor.svg", import.meta.url).href,
);
export const IconDirections = /*#__PURE__*/ makeIcon(
  "directions",
  new URL("./sprites/directions.svg", import.meta.url).href,
);
export const IconDirectory = /*#__PURE__*/ makeIcon(
  "directory",
  new URL("./sprites/directory.svg", import.meta.url).href,
);
export const IconDirectoryFilled = /*#__PURE__*/ makeIcon(
  "directoryFilled",
  new URL("./sprites/directoryFilled.svg", import.meta.url).href,
);
export const IconDivisionThick = /*#__PURE__*/ makeIcon(
  "divisionThick",
  new URL("./sprites/divisionThick.svg", import.meta.url).href,
);
export const IconDojoPlus = /*#__PURE__*/ makeIcon("dojoPlus", new URL("./sprites/dojoPlus.svg", import.meta.url).href);
export const IconDojoTutor = /*#__PURE__*/ makeIcon(
  "dojoTutor",
  new URL("./sprites/dojoTutor.svg", import.meta.url).href,
);
export const IconDojosafe = /*#__PURE__*/ makeIcon("dojosafe", new URL("./sprites/dojosafe.svg", import.meta.url).href);
export const IconDoubleCheck = /*#__PURE__*/ makeIcon(
  "doubleCheck",
  new URL("./sprites/doubleCheck.svg", import.meta.url).href,
);
export const IconDownload = /*#__PURE__*/ makeIcon("download", new URL("./sprites/download.svg", import.meta.url).href);
export const IconDude = /*#__PURE__*/ makeIcon("dude", new URL("./sprites/dude.svg", import.meta.url).href);
export const IconDudeFilled = /*#__PURE__*/ makeIcon(
  "dudeFilled",
  new URL("./sprites/dudeFilled.svg", import.meta.url).href,
);
export const IconExpand = /*#__PURE__*/ makeIcon("expand", new URL("./sprites/expand.svg", import.meta.url).href);
export const IconEye = /*#__PURE__*/ makeIcon("eye", new URL("./sprites/eye.svg", import.meta.url).href);
export const IconEyeHidden = /*#__PURE__*/ makeIcon(
  "eyeHidden",
  new URL("./sprites/eyeHidden.svg", import.meta.url).href,
);
export const IconFastForward = /*#__PURE__*/ makeIcon(
  "fastForward",
  new URL("./sprites/fastForward.svg", import.meta.url).href,
);
export const IconFastRewind = /*#__PURE__*/ makeIcon(
  "fastRewind",
  new URL("./sprites/fastRewind.svg", import.meta.url).href,
);
export const IconFavorite = /*#__PURE__*/ makeIcon("favorite", new URL("./sprites/favorite.svg", import.meta.url).href);
export const IconFavoriteFilled = /*#__PURE__*/ makeIcon(
  "favoriteFilled",
  new URL("./sprites/favoriteFilled.svg", import.meta.url).href,
);
export const IconFileAudio = /*#__PURE__*/ makeIcon(
  "fileAudio",
  new URL("./sprites/fileAudio.svg", import.meta.url).href,
);
export const IconFileDocument = /*#__PURE__*/ makeIcon(
  "fileDocument",
  new URL("./sprites/fileDocument.svg", import.meta.url).href,
);
export const IconFileDocumentFilled = /*#__PURE__*/ makeIcon(
  "fileDocumentFilled",
  new URL("./sprites/fileDocumentFilled.svg", import.meta.url).href,
);
export const IconFileVideo = /*#__PURE__*/ makeIcon(
  "fileVideo",
  new URL("./sprites/fileVideo.svg", import.meta.url).href,
);
export const IconFilter = /*#__PURE__*/ makeIcon("filter", new URL("./sprites/filter.svg", import.meta.url).href);
export const IconFilterTwo = /*#__PURE__*/ makeIcon(
  "filterTwo",
  new URL("./sprites/filterTwo.svg", import.meta.url).href,
);
export const IconFlagOne = /*#__PURE__*/ makeIcon("flagOne", new URL("./sprites/flagOne.svg", import.meta.url).href);
export const IconFlagThree = /*#__PURE__*/ makeIcon(
  "flagThree",
  new URL("./sprites/flagThree.svg", import.meta.url).href,
);
export const IconFlagTwo = /*#__PURE__*/ makeIcon("flagTwo", new URL("./sprites/flagTwo.svg", import.meta.url).href);
export const IconFlashOff = /*#__PURE__*/ makeIcon("flashOff", new URL("./sprites/flashOff.svg", import.meta.url).href);
export const IconFlashOn = /*#__PURE__*/ makeIcon("flashOn", new URL("./sprites/flashOn.svg", import.meta.url).href);
export const IconFolder = /*#__PURE__*/ makeIcon("folder", new URL("./sprites/folder.svg", import.meta.url).href);
export const IconForwardTen = /*#__PURE__*/ makeIcon(
  "forwardTen",
  new URL("./sprites/forwardTen.svg", import.meta.url).href,
);
export const IconGifBox = /*#__PURE__*/ makeIcon("gifBox", new URL("./sprites/gifBox.svg", import.meta.url).href);
export const IconGifBoxFilled = /*#__PURE__*/ makeIcon(
  "gifBoxFilled",
  new URL("./sprites/gifBoxFilled.svg", import.meta.url).href,
);
export const IconGlobe = /*#__PURE__*/ makeIcon("globe", new URL("./sprites/globe.svg", import.meta.url).href);
export const IconGraduate = /*#__PURE__*/ makeIcon("graduate", new URL("./sprites/graduate.svg", import.meta.url).href);
export const IconGrid = /*#__PURE__*/ makeIcon("grid", new URL("./sprites/grid.svg", import.meta.url).href);
export const IconGroup = /*#__PURE__*/ makeIcon("group", new URL("./sprites/group.svg", import.meta.url).href);
export const IconHanger = /*#__PURE__*/ makeIcon("hanger", new URL("./sprites/hanger.svg", import.meta.url).href);
export const IconHeart = /*#__PURE__*/ makeIcon("heart", new URL("./sprites/heart.svg", import.meta.url).href);
export const IconHeartFilled = /*#__PURE__*/ makeIcon(
  "heartFilled",
  new URL("./sprites/heartFilled.svg", import.meta.url).href,
);
export const IconHeartFilledAdd = /*#__PURE__*/ makeIcon(
  "heartFilledAdd",
  new URL("./sprites/heartFilledAdd.svg", import.meta.url).href,
);
export const IconHeartFilledRemove = /*#__PURE__*/ makeIcon(
  "heartFilledRemove",
  new URL("./sprites/heartFilledRemove.svg", import.meta.url).href,
);
export const IconHelpCircle = /*#__PURE__*/ makeIcon(
  "helpCircle",
  new URL("./sprites/helpCircle.svg", import.meta.url).href,
);
export const IconHelpCircleFilled = /*#__PURE__*/ makeIcon(
  "helpCircleFilled",
  new URL("./sprites/helpCircleFilled.svg", import.meta.url).href,
);
export const IconHistory = /*#__PURE__*/ makeIcon("history", new URL("./sprites/history.svg", import.meta.url).href);
export const IconHouse = /*#__PURE__*/ makeIcon("house", new URL("./sprites/house.svg", import.meta.url).href);
export const IconIDCard = /*#__PURE__*/ makeIcon("iDCard", new URL("./sprites/iDCard.svg", import.meta.url).href);
export const IconInbox = /*#__PURE__*/ makeIcon("inbox", new URL("./sprites/inbox.svg", import.meta.url).href);
export const IconIslandOne = /*#__PURE__*/ makeIcon(
  "islandOne",
  new URL("./sprites/islandOne.svg", import.meta.url).href,
);
export const IconIslandTwo = /*#__PURE__*/ makeIcon(
  "islandTwo",
  new URL("./sprites/islandTwo.svg", import.meta.url).href,
);
export const IconKatie = /*#__PURE__*/ makeIcon("katie", new URL("./sprites/katie.svg", import.meta.url).href);
export const IconLeader = /*#__PURE__*/ makeIcon("leader", new URL("./sprites/leader.svg", import.meta.url).href);
export const IconLeaderFilled = /*#__PURE__*/ makeIcon(
  "leaderFilled",
  new URL("./sprites/leaderFilled.svg", import.meta.url).href,
);
export const IconLightbulb = /*#__PURE__*/ makeIcon(
  "lightbulb",
  new URL("./sprites/lightbulb.svg", import.meta.url).href,
);
export const IconLink = /*#__PURE__*/ makeIcon("link", new URL("./sprites/link.svg", import.meta.url).href);
export const IconList = /*#__PURE__*/ makeIcon("list", new URL("./sprites/list.svg", import.meta.url).href);
export const IconLockClosed = /*#__PURE__*/ makeIcon(
  "lockClosed",
  new URL("./sprites/lockClosed.svg", import.meta.url).href,
);
export const IconLockOpen = /*#__PURE__*/ makeIcon("lockOpen", new URL("./sprites/lockOpen.svg", import.meta.url).href);
export const IconLogin = /*#__PURE__*/ makeIcon("login", new URL("./sprites/login.svg", import.meta.url).href);
export const IconLogout = /*#__PURE__*/ makeIcon("logout", new URL("./sprites/logout.svg", import.meta.url).href);
export const IconLoop = /*#__PURE__*/ makeIcon("loop", new URL("./sprites/loop.svg", import.meta.url).href);
export const IconMagic = /*#__PURE__*/ makeIcon("magic", new URL("./sprites/magic.svg", import.meta.url).href);
export const IconMail = /*#__PURE__*/ makeIcon("mail", new URL("./sprites/mail.svg", import.meta.url).href);
export const IconMegaphone = /*#__PURE__*/ makeIcon(
  "megaphone",
  new URL("./sprites/megaphone.svg", import.meta.url).href,
);
export const IconMentorBadge = /*#__PURE__*/ makeIcon(
  "mentorBadge",
  new URL("./sprites/mentorBadge.svg", import.meta.url).href,
);
export const IconMenu = /*#__PURE__*/ makeIcon("menu", new URL("./sprites/menu.svg", import.meta.url).href);
export const IconMerge = /*#__PURE__*/ makeIcon("merge", new URL("./sprites/merge.svg", import.meta.url).href);
export const IconMergeAlt = /*#__PURE__*/ makeIcon("mergeAlt", new URL("./sprites/mergeAlt.svg", import.meta.url).href);
export const IconMessage = /*#__PURE__*/ makeIcon("message", new URL("./sprites/message.svg", import.meta.url).href);
export const IconMessageFilled = /*#__PURE__*/ makeIcon(
  "messageFilled",
  new URL("./sprites/messageFilled.svg", import.meta.url).href,
);
export const IconMessageLined = /*#__PURE__*/ makeIcon(
  "messageLined",
  new URL("./sprites/messageLined.svg", import.meta.url).href,
);
export const IconMessageMarkunread = /*#__PURE__*/ makeIcon(
  "messageMarkunread",
  new URL("./sprites/messageMarkunread.svg", import.meta.url).href,
);
export const IconMessageMass = /*#__PURE__*/ makeIcon(
  "messageMass",
  new URL("./sprites/messageMass.svg", import.meta.url).href,
);
export const IconMic = /*#__PURE__*/ makeIcon("mic", new URL("./sprites/mic.svg", import.meta.url).href);
export const IconMinus = /*#__PURE__*/ makeIcon("minus", new URL("./sprites/minus.svg", import.meta.url).href);
export const IconMinusCircle = /*#__PURE__*/ makeIcon(
  "minusCircle",
  new URL("./sprites/minusCircle.svg", import.meta.url).href,
);
export const IconMinusCircleFilled = /*#__PURE__*/ makeIcon(
  "minusCircleFilled",
  new URL("./sprites/minusCircleFilled.svg", import.meta.url).href,
);
export const IconMojo = /*#__PURE__*/ makeIcon("mojo", new URL("./sprites/mojo.svg", import.meta.url).href);
export const IconMonster = /*#__PURE__*/ makeIcon("monster", new URL("./sprites/monster.svg", import.meta.url).href);
export const IconMonsterGroupFilled = /*#__PURE__*/ makeIcon(
  "monsterGroupFilled",
  new URL("./sprites/monsterGroupFilled.svg", import.meta.url).href,
);
export const IconMoreHorizontal = /*#__PURE__*/ makeIcon(
  "moreHorizontal",
  new URL("./sprites/moreHorizontal.svg", import.meta.url).href,
);
export const IconMoreVertical = /*#__PURE__*/ makeIcon(
  "moreVertical",
  new URL("./sprites/moreVertical.svg", import.meta.url).href,
);
export const IconMusic = /*#__PURE__*/ makeIcon("music", new URL("./sprites/music.svg", import.meta.url).href);
export const IconNight = /*#__PURE__*/ makeIcon("night", new URL("./sprites/night.svg", import.meta.url).href);
export const IconNo = /*#__PURE__*/ makeIcon("no", new URL("./sprites/no.svg", import.meta.url).href);
export const IconNoFilled = /*#__PURE__*/ makeIcon("noFilled", new URL("./sprites/noFilled.svg", import.meta.url).href);
export const IconOpenin = /*#__PURE__*/ makeIcon("openin", new URL("./sprites/openin.svg", import.meta.url).href);
export const IconOpeninAlt = /*#__PURE__*/ makeIcon(
  "openinAlt",
  new URL("./sprites/openinAlt.svg", import.meta.url).href,
);
export const IconPause = /*#__PURE__*/ makeIcon("pause", new URL("./sprites/pause.svg", import.meta.url).href);
export const IconPencil = /*#__PURE__*/ makeIcon("pencil", new URL("./sprites/pencil.svg", import.meta.url).href);
export const IconPhone = /*#__PURE__*/ makeIcon("phone", new URL("./sprites/phone.svg", import.meta.url).href);
export const IconPhoneNew = /*#__PURE__*/ makeIcon("phoneNew", new URL("./sprites/phoneNew.svg", import.meta.url).href);
export const IconPhoto = /*#__PURE__*/ makeIcon("photo", new URL("./sprites/photo.svg", import.meta.url).href);
export const IconPhotoAdd = /*#__PURE__*/ makeIcon("photoAdd", new URL("./sprites/photoAdd.svg", import.meta.url).href);
export const IconPhotoFav = /*#__PURE__*/ makeIcon("photoFav", new URL("./sprites/photoFav.svg", import.meta.url).href);
export const IconPhotoFilled = /*#__PURE__*/ makeIcon(
  "photoFilled",
  new URL("./sprites/photoFilled.svg", import.meta.url).href,
);
export const IconPhotoMultiple = /*#__PURE__*/ makeIcon(
  "photoMultiple",
  new URL("./sprites/photoMultiple.svg", import.meta.url).href,
);
export const IconPhotoMultipleFilled = /*#__PURE__*/ makeIcon(
  "photoMultipleFilled",
  new URL("./sprites/photoMultipleFilled.svg", import.meta.url).href,
);
export const IconPhotoTag = /*#__PURE__*/ makeIcon("photoTag", new URL("./sprites/photoTag.svg", import.meta.url).href);
export const IconPinLocation = /*#__PURE__*/ makeIcon(
  "pinLocation",
  new URL("./sprites/pinLocation.svg", import.meta.url).href,
);
export const IconPinLocationFilled = /*#__PURE__*/ makeIcon(
  "pinLocationFilled",
  new URL("./sprites/pinLocationFilled.svg", import.meta.url).href,
);
export const IconPlay = /*#__PURE__*/ makeIcon("play", new URL("./sprites/play.svg", import.meta.url).href);
export const IconPlus = /*#__PURE__*/ makeIcon("plus", new URL("./sprites/plus.svg", import.meta.url).href);
export const IconPlusCircle = /*#__PURE__*/ makeIcon(
  "plusCircle",
  new URL("./sprites/plusCircle.svg", import.meta.url).href,
);
export const IconPlusCircleFilled = /*#__PURE__*/ makeIcon(
  "plusCircleFilled",
  new URL("./sprites/plusCircleFilled.svg", import.meta.url).href,
);
export const IconPoints = /*#__PURE__*/ makeIcon("points", new URL("./sprites/points.svg", import.meta.url).href);
export const IconPointsAdd = /*#__PURE__*/ makeIcon(
  "pointsAdd",
  new URL("./sprites/pointsAdd.svg", import.meta.url).href,
);
export const IconPointsReset = /*#__PURE__*/ makeIcon(
  "pointsReset",
  new URL("./sprites/pointsReset.svg", import.meta.url).href,
);
export const IconPrinter = /*#__PURE__*/ makeIcon("printer", new URL("./sprites/printer.svg", import.meta.url).href);
export const IconQrCode = /*#__PURE__*/ makeIcon("qrCode", new URL("./sprites/qrCode.svg", import.meta.url).href);
export const IconQuote = /*#__PURE__*/ makeIcon("quote", new URL("./sprites/quote.svg", import.meta.url).href);
export const IconReactAdd = /*#__PURE__*/ makeIcon("reactAdd", new URL("./sprites/reactAdd.svg", import.meta.url).href);
export const IconRefreshClockwise = /*#__PURE__*/ makeIcon(
  "refreshClockwise",
  new URL("./sprites/refreshClockwise.svg", import.meta.url).href,
);
export const IconRefreshClockwiseAlt = /*#__PURE__*/ makeIcon(
  "refreshClockwiseAlt",
  new URL("./sprites/refreshClockwiseAlt.svg", import.meta.url).href,
);
export const IconRefreshCounterAlt = /*#__PURE__*/ makeIcon(
  "refreshCounterAlt",
  new URL("./sprites/refreshCounterAlt.svg", import.meta.url).href,
);
export const IconRepeat = /*#__PURE__*/ makeIcon("repeat", new URL("./sprites/repeat.svg", import.meta.url).href);
export const IconRocket = /*#__PURE__*/ makeIcon("rocket", new URL("./sprites/rocket.svg", import.meta.url).href);
export const IconSave = /*#__PURE__*/ makeIcon("save", new URL("./sprites/save.svg", import.meta.url).href);
export const IconSchoolOne = /*#__PURE__*/ makeIcon(
  "schoolOne",
  new URL("./sprites/schoolOne.svg", import.meta.url).href,
);
export const IconSchoolOneFilled = /*#__PURE__*/ makeIcon(
  "schoolOneFilled",
  new URL("./sprites/schoolOneFilled.svg", import.meta.url).href,
);
export const IconSchoolTwo = /*#__PURE__*/ makeIcon(
  "schoolTwo",
  new URL("./sprites/schoolTwo.svg", import.meta.url).href,
);
export const IconSchoolTwoFilled = /*#__PURE__*/ makeIcon(
  "schoolTwoFilled",
  new URL("./sprites/schoolTwoFilled.svg", import.meta.url).href,
);
export const IconSearch = /*#__PURE__*/ makeIcon("search", new URL("./sprites/search.svg", import.meta.url).href);
export const IconSearchPlain = /*#__PURE__*/ makeIcon(
  "searchPlain",
  new URL("./sprites/searchPlain.svg", import.meta.url).href,
);
export const IconSearchThick = /*#__PURE__*/ makeIcon(
  "searchThick",
  new URL("./sprites/searchThick.svg", import.meta.url).href,
);
export const IconSend = /*#__PURE__*/ makeIcon("send", new URL("./sprites/send.svg", import.meta.url).href);
export const IconSendAlt = /*#__PURE__*/ makeIcon("sendAlt", new URL("./sprites/sendAlt.svg", import.meta.url).href);
export const IconSettings = /*#__PURE__*/ makeIcon("settings", new URL("./sprites/settings.svg", import.meta.url).href);
export const IconSettingsFilled = /*#__PURE__*/ makeIcon(
  "settingsFilled",
  new URL("./sprites/settingsFilled.svg", import.meta.url).href,
);
export const IconShare = /*#__PURE__*/ makeIcon("share", new URL("./sprites/share.svg", import.meta.url).href);
export const IconShareTwo = /*#__PURE__*/ makeIcon("shareTwo", new URL("./sprites/shareTwo.svg", import.meta.url).href);
export const IconShuffle = /*#__PURE__*/ makeIcon("shuffle", new URL("./sprites/shuffle.svg", import.meta.url).href);
export const IconSpeedometer = /*#__PURE__*/ makeIcon(
  "speedometer",
  new URL("./sprites/speedometer.svg", import.meta.url).href,
);
export const IconSpinner = /*#__PURE__*/ makeIcon("spinner", new URL("./sprites/spinner.svg", import.meta.url).href);
export const IconSticker = /*#__PURE__*/ makeIcon("sticker", new URL("./sprites/sticker.svg", import.meta.url).href);
export const IconStickerFilled = /*#__PURE__*/ makeIcon(
  "stickerFilled",
  new URL("./sprites/stickerFilled.svg", import.meta.url).href,
);
export const IconStop = /*#__PURE__*/ makeIcon("stop", new URL("./sprites/stop.svg", import.meta.url).href);
export const IconStopwatch = /*#__PURE__*/ makeIcon(
  "stopwatch",
  new URL("./sprites/stopwatch.svg", import.meta.url).href,
);
export const IconStopwatchFilled = /*#__PURE__*/ makeIcon(
  "stopwatchFilled",
  new URL("./sprites/stopwatchFilled.svg", import.meta.url).href,
);
export const IconThumbsup = /*#__PURE__*/ makeIcon("thumbsup", new URL("./sprites/thumbsup.svg", import.meta.url).href);
export const IconThumbtack = /*#__PURE__*/ makeIcon(
  "thumbtack",
  new URL("./sprites/thumbtack.svg", import.meta.url).href,
);
export const IconToEnd = /*#__PURE__*/ makeIcon("toEnd", new URL("./sprites/toEnd.svg", import.meta.url).href);
export const IconToStart = /*#__PURE__*/ makeIcon("toStart", new URL("./sprites/toStart.svg", import.meta.url).href);
export const IconTranslate = /*#__PURE__*/ makeIcon(
  "translate",
  new URL("./sprites/translate.svg", import.meta.url).href,
);
export const IconTranslateTwo = /*#__PURE__*/ makeIcon(
  "translateTwo",
  new URL("./sprites/translateTwo.svg", import.meta.url).href,
);
export const IconTrash = /*#__PURE__*/ makeIcon("trash", new URL("./sprites/trash.svg", import.meta.url).href);
export const IconTrashFilled = /*#__PURE__*/ makeIcon(
  "trashFilled",
  new URL("./sprites/trashFilled.svg", import.meta.url).href,
);
export const IconTriangleDown = /*#__PURE__*/ makeIcon(
  "triangleDown",
  new URL("./sprites/triangleDown.svg", import.meta.url).href,
);
export const IconTriangleDownLeft = /*#__PURE__*/ makeIcon(
  "triangleDownLeft",
  new URL("./sprites/triangleDownLeft.svg", import.meta.url).href,
);
export const IconTriangleDownRight = /*#__PURE__*/ makeIcon(
  "triangleDownRight",
  new URL("./sprites/triangleDownRight.svg", import.meta.url).href,
);
export const IconTriangleLeft = /*#__PURE__*/ makeIcon(
  "triangleLeft",
  new URL("./sprites/triangleLeft.svg", import.meta.url).href,
);
export const IconTriangleRight = /*#__PURE__*/ makeIcon(
  "triangleRight",
  new URL("./sprites/triangleRight.svg", import.meta.url).href,
);
export const IconTriangleUp = /*#__PURE__*/ makeIcon(
  "triangleUp",
  new URL("./sprites/triangleUp.svg", import.meta.url).href,
);
export const IconTriangleUpLeft = /*#__PURE__*/ makeIcon(
  "triangleUpLeft",
  new URL("./sprites/triangleUpLeft.svg", import.meta.url).href,
);
export const IconTriangleUpRight = /*#__PURE__*/ makeIcon(
  "triangleUpRight",
  new URL("./sprites/triangleUpRight.svg", import.meta.url).href,
);
export const IconTurnDownLeft = /*#__PURE__*/ makeIcon(
  "turnDownLeft",
  new URL("./sprites/turnDownLeft.svg", import.meta.url).href,
);
export const IconTurnDownRight = /*#__PURE__*/ makeIcon(
  "turnDownRight",
  new URL("./sprites/turnDownRight.svg", import.meta.url).href,
);
export const IconTurnLeftDown = /*#__PURE__*/ makeIcon(
  "turnLeftDown",
  new URL("./sprites/turnLeftDown.svg", import.meta.url).href,
);
export const IconTurnLeftUp = /*#__PURE__*/ makeIcon(
  "turnLeftUp",
  new URL("./sprites/turnLeftUp.svg", import.meta.url).href,
);
export const IconTurnRightDown = /*#__PURE__*/ makeIcon(
  "turnRightDown",
  new URL("./sprites/turnRightDown.svg", import.meta.url).href,
);
export const IconTurnRightUp = /*#__PURE__*/ makeIcon(
  "turnRightUp",
  new URL("./sprites/turnRightUp.svg", import.meta.url).href,
);
export const IconTurnUpLeft = /*#__PURE__*/ makeIcon(
  "turnUpLeft",
  new URL("./sprites/turnUpLeft.svg", import.meta.url).href,
);
export const IconTurnUpRight = /*#__PURE__*/ makeIcon(
  "turnUpRight",
  new URL("./sprites/turnUpRight.svg", import.meta.url).href,
);
export const IconUndo = /*#__PURE__*/ makeIcon("undo", new URL("./sprites/undo.svg", import.meta.url).href);
export const IconUndoAlt = /*#__PURE__*/ makeIcon("undoAlt", new URL("./sprites/undoAlt.svg", import.meta.url).href);
export const IconUpload = /*#__PURE__*/ makeIcon("upload", new URL("./sprites/upload.svg", import.meta.url).href);
export const IconUser = /*#__PURE__*/ makeIcon("user", new URL("./sprites/user.svg", import.meta.url).href);
export const IconUserAdd = /*#__PURE__*/ makeIcon("userAdd", new URL("./sprites/userAdd.svg", import.meta.url).href);
export const IconUturnDown = /*#__PURE__*/ makeIcon(
  "uturnDown",
  new URL("./sprites/uturnDown.svg", import.meta.url).href,
);
export const IconUturnLeft = /*#__PURE__*/ makeIcon(
  "uturnLeft",
  new URL("./sprites/uturnLeft.svg", import.meta.url).href,
);
export const IconUturnRight = /*#__PURE__*/ makeIcon(
  "uturnRight",
  new URL("./sprites/uturnRight.svg", import.meta.url).href,
);
export const IconUturnUp = /*#__PURE__*/ makeIcon("uturnUp", new URL("./sprites/uturnUp.svg", import.meta.url).href);
export const IconVideo = /*#__PURE__*/ makeIcon("video", new URL("./sprites/video.svg", import.meta.url).href);
export const IconVideocamera = /*#__PURE__*/ makeIcon(
  "videocamera",
  new URL("./sprites/videocamera.svg", import.meta.url).href,
);
export const IconVolumnOff = /*#__PURE__*/ makeIcon(
  "volumnOff",
  new URL("./sprites/volumnOff.svg", import.meta.url).href,
);
export const IconVolumnOn = /*#__PURE__*/ makeIcon("volumnOn", new URL("./sprites/volumnOn.svg", import.meta.url).href);
export const IconX = /*#__PURE__*/ makeIcon("x", new URL("./sprites/x.svg", import.meta.url).href);
export const IconXCircle = /*#__PURE__*/ makeIcon("xCircle", new URL("./sprites/xCircle.svg", import.meta.url).href);
export const IconXCircleFilled = /*#__PURE__*/ makeIcon(
  "xCircleFilled",
  new URL("./sprites/xCircleFilled.svg", import.meta.url).href,
);
